/**
 * Shared list sort defaults and menu options.
 * Controllers seed initial state; Lists use resetListSort() in resetOptions.
 */
export const DEFAULT_LIST_SORT = {
  sortBy: "updated_at",
  sortDirection: "DESC",
};

export const TIMESTAMP_SORT_OPTIONS = [
  { text: "Created", sortBy: "created_at" },
  { text: "Updated", sortBy: "updated_at" },
];

export function withTimestampSortOptions(baseOptions) {
  const baseFields = new Set(baseOptions.map((o) => o.sortBy));
  return [
    ...baseOptions,
    ...TIMESTAMP_SORT_OPTIONS.filter((o) => !baseFields.has(o.sortBy)),
  ];
}

export function resetListSort() {
  return { ...DEFAULT_LIST_SORT };
}
